import { render, staticRenderFns } from "./Add-CoursePage.vue?vue&type=template&id=5a1415f0&scoped=true&"
import script from "./Add-CoursePage.vue?vue&type=script&lang=js&"
export * from "./Add-CoursePage.vue?vue&type=script&lang=js&"
import style0 from "./Add-CoursePage.vue?vue&type=style&index=0&id=5a1415f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1415f0",
  null
  
)

export default component.exports